(function () {
  'use strict'

  /**
   * @ngdoc module
   * @name GlowConfig
   * @module thismoment.glow.config
   *
   * @description
   * Allows glow page and modules access to Glow Configuration settings. Use
   * this service to pass settings between Glow modules.
   */

  var MODULE_NAME = 'thismoment.glow.config'

  require('angular')
    .module(MODULE_NAME, [
      require('../config')
    ])
    .provider('GlowConfig', glowConfigProvider)

  glowConfigProvider.$inject = ['$windowProvider', 'ThismomentConfigProvider']
  function glowConfigProvider ($windowProvider, ThismomentConfigProvider) {
    var $window = $windowProvider.$get()
    var ThismomentConfig = ThismomentConfigProvider
    var GlowConfig = ThismomentConfig.setupConfig(angular.merge({
      pages: [],
      modules: []
    }, $window.CCMT_GLOW), {
      getCart: getCart,
      getCurrentPage: getCurrentPage,
      getModule: getModule,
      getPage: getPage,
      getPages: getPages,
      getPageBy: getPageBy
    })

    return {
      $get: glowConfigService
    }

    function glowConfigService () {
      return GlowConfig
    }

    /**
     * @ngdoc function
     * @name getCart
     * @module thismoment.glow.config
     *
     * @returns {ThismomentConfig|array} Cart configuration object
     *
     * @description Return a glow page configuration object (null if not found)
     */
    function getCart () {
      return ThismomentConfig.setupConfig(this.get('cart'))
    }

    /**
     * @ngdoc function
     * @name getModule
     * @module thismoment.glow.config
     *
     * @param {string} id the desired module's id
     * @param {string} type the desired module's type
     * @returns {ThismomentConfig|null} Configuration object, or nothing if not found
     *
     * @description Return a glow module configuration object (null if not found)
     */
    function getModule (id) {
      var module = this.get('modules').filter(function (module) {
        return (parseInt(module.id) === parseInt(id))
      })

      return module.length ? ThismomentConfig.setupConfig(module[0]) : []
    }

    /**
     * @ngdoc function
     * @name getPage
     * @module thismoment.glow.config
     *
     * @param {string} id the glow page's id
     * @returns {ThismomentConfig|null} Configuration object, or nothing if not found
     *
     * @description Return a glow page configuration object (null if not found)
     */
    function getPage (id) {
      var page = this.get('pages').filter(function (page) {
        return parseInt(page.id) === parseInt(id)
      })

      return page.length ? ThismomentConfig.setupConfig(page[0]) : []
    }

    /**
     * @ngdoc function
     * @name getPages
     * @module thismoment.glow.config
     *
     * @returns {array} Array of configuration objects. Empty if none found.
     *
     * @description Return an array of glow page configuration objects
     */
    function getPages () {
      return this.get('pages').map(function (page) {
        return ThismomentConfig.setupConfig(page)
      })
    }

    /**
     * @ngdoc function
     * @name getPageBy
     * @module thismoment.glow.config
     *
     * @param {string} key target key to filter by
     * @param {string} value value to search for
     * @returns {ThismomentConfig|null} Configuration object, or nothing if not found
     *
     * @description Return a glow page configuration object (null if not found)
     */
    function getPageBy (key, value) {
      var page = this.get('pages').filter(function (page) {
        return page[key] === value
      })

      return page.length ? ThismomentConfig.setupConfig(page[0]) : null
    }

    function getCurrentPage () {
      const currentPath = $window.location.pathname.slice(1)
      const page = this.get('pages').filter(function (page) {
        return page.path === currentPath
      })

      return page.length ? ThismomentConfig.setupConfig(page[0]) : []
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/glow-config.js